// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useUserService: () => UseQueryResult<TemplateContract<UserService> | null, string> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator, party } = useParties();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryCredentialUserService', offset, ledgerApi, operator, party],
    queryFn: async () => {
      return ledgerApi.queryCredentialUserService(offset!, operator, party);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useUserService;
